// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import Sidebar from './Sidebar';
// import flag from "../assets/IMG2.png";
// import { FaChevronDown, FaChevronUp } from "react-icons/fa";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";

// const BookingList = () => {
//     const [bookings, setBookings] = useState([]);
//     const [filteredBookings, setFilteredBookings] = useState([]);
//     const [statusFilter, setStatusFilter] = useState("All");
//     const [showDropdown, setShowDropdown] = useState(false);
//     const [currentPage, setCurrentPage] = useState(1);
//     const [pendingBookings, setPendingBookings] = useState([]);
    
//     const bookingsPerPage = 5;

//     useEffect(() => {
//         fetchBookings();
//     }, []);

//     const fetchBookings = async () => {
//         try {
//             const response = await axios.get('https://carrentalbackend.dockyardsoftware.com/api/Bookings');
//             const sortedBookings = response.data.sort((a, b) => b.id - a.id); // Sort by ID in descending order
//             setBookings(sortedBookings);
//             setFilteredBookings(sortedBookings);
//         } catch (error) {
//             console.error("There was an error fetching the bookings!", error);
//         }
//     };
    

//     const shouldShowActions = filteredBookings.some(
//         (booking) => booking.status === "Pending" || booking.status === "Approved"
//     );
    

//     const handleStatusFilterChange = (status) => {
//         setStatusFilter(status);
//         setShowDropdown(false);
//         setCurrentPage(1);
//         if (status === "All") {
//             setFilteredBookings(bookings);
//         } else {
//             setFilteredBookings(bookings.filter(b => b.status === status));
//         }
//     };

//    const handleApprove = async (id) => {
//     try {
//         await axios.post(`https://carrentalbackend.dockyardsoftware.com/api/Bookings/approve/${id}`);
//         setBookings((prevBookings) =>
//             prevBookings.map((b) =>
//                 b.id === id ? { ...b, status: "Approved" } : b
//             )
//         );
//         setFilteredBookings((prevFiltered) =>
//             prevFiltered.map((b) =>
//                 b.id === id ? { ...b, status: "Approved" } : b
//             )
//         );
//     } catch (error) {
//         console.error("Error approving booking:", error);
//     }
// };

// const handleReject = async (id) => {
//     try {
//         await axios.post(`https://carrentalbackend.dockyardsoftware.com/api/Bookings/reject/${id}`);
//         setBookings((prevBookings) =>
//             prevBookings.map((b) =>
//                 b.id === id ? { ...b, status: "Rejected" } : b
//             )
//         );
//         setFilteredBookings((prevFiltered) =>
//             prevFiltered.map((b) =>
//                 b.id === id ? { ...b, status: "Rejected" } : b
//             )
//         );
//     } catch (error) {
//         console.error("Error rejecting booking:", error);
//     }
// };

// const handleRelease = async (id) => {
//     try {
//         await axios.post(`https://carrentalbackend.dockyardsoftware.com/api/Bookings/release/${id}`);
//         setBookings((prevBookings) =>
//             prevBookings.map((b) =>
//                 b.id === id ? { ...b, status: "Released" } : b
//             )
//         );
//         setFilteredBookings((prevFiltered) =>
//             prevFiltered.map((b) =>
//                 b.id === id ? { ...b, status: "Released" } : b
//             )
//         );
//     } catch (error) {
//         console.error("Error releasing car:", error);
//     }
// };


//     const indexOfLastBooking = currentPage * bookingsPerPage;
//     const indexOfFirstBooking = indexOfLastBooking - bookingsPerPage;
//     const currentBookings = filteredBookings.slice(indexOfFirstBooking, indexOfLastBooking);
//     const [pickupDateFilter, setPickupDateFilter] = useState("");
// const [dropoffDateFilter, setDropoffDateFilter] = useState("");

// const formatDate = (date) => {
//     if (!date) return "";
//     const d = new Date(date);
//     return `${d.getFullYear()}/${String(d.getMonth() + 1).padStart(2, '0')}/${String(d.getDate()).padStart(2, '0')}`;
// };

// const handleFilterByDate = () => {
//     let filtered = bookings;

//     if (pickupDateFilter) {
//         filtered = filtered.filter(
//             (b) => formatDate(b.pickupDate) === formatDate(pickupDateFilter)
//         );
//     }

//     if (dropoffDateFilter) {
//         filtered = filtered.filter(
//             (b) => formatDate(b.dropoffDate) === formatDate(dropoffDateFilter)
//         );
//     }

//     setFilteredBookings(filtered);
// };



//     const paginate = (pageNumber) => setCurrentPage(pageNumber);

//     return (
//         <div className="flex h-screen">
//             <Sidebar />
//             <div className="flex-1 p-6 overflow-auto">
//                 <img src={flag} alt="Logo" className="h-10 w-auto mr-2" />
//                 <div className="mt-6 relative">
//                     <div className="relative bg-white lg:w-[90%] w-[100%] lg:mx-3 lg:px-10 lg:py-10 p-5 lg:rounded-tl-[3rem] rounded-lg shadow-xl">
//                         <h3 className="text-xl font-bold mb-2">Pending Bookings</h3>

                         
//                     {/* Date Filters */}
//                     <div className="flex space-x-4 mb-6">
//                         <div className="flex items-center border px-3 py-2 rounded-lg shadow-sm w-full text-sm">
//                             <DatePicker
//                                 selected={pickupDateFilter}
//                                 onChange={(date) => setPickupDateFilter(date)}
//                                 dateFormat="yyyy/MM/dd"
//                                 className="focus:outline-none w-full"
//                                 placeholderText="Pickup Date..."
//                             />
//                         </div>
//                         <div className="flex items-center border px-3 py-2 rounded-lg shadow-sm w-full text-sm">
//                             <DatePicker
//                                 selected={dropoffDateFilter}
//                                 onChange={(date) => setDropoffDateFilter(date)}
//                                 dateFormat="yyyy/MM/dd"
//                                 className="focus:outline-none w-full"
//                                 placeholderText="Dropoff Date..."
//                             />
//                         </div>
//                         <button className="bg-blue-500 text-white px-4 py-2 rounded" onClick={handleFilterByDate}>
//                             Search
//                         </button>
//                     </div>


//                         <table className="w-full text-sm text-left text-gray-500">
//                             <thead className="text-xs text-gray-700 uppercase bg-gray-200">
//                                 <tr className="bg-gray-100">
//                                     <th className="px-6 py-3">ID</th>
//                                     <th className="px-6 py-3">Name</th>
//                                     <th className="px-6 py-3">Car Name</th>
//                                     <th className="px-6 py-3">Pickup Date</th>
//                                     <th className="px-6 py-3">Dropoff Date</th>
//                                     <th className="px-6 py-3 relative">
//                                         Status
//                                         <button onClick={() => setShowDropdown(!showDropdown)} className="ml-2 text-gray-600">
//                                             {showDropdown ? <FaChevronUp /> : <FaChevronDown />}
//                                         </button>
//                                         {showDropdown && (
//                                             <div className="absolute top-10 left-0 bg-white shadow-md rounded-md w-32 z-10">
//                                                 <ul className="text-sm">
//                                                     {["All", "Pending", "Approved", "Rejected", "Released"].map((status) => (
//                                                         <li key={status} className="px-4 py-2 cursor-pointer hover:bg-gray-100" onClick={() => handleStatusFilterChange(status)}>
//                                                             {status === "Approved" ? "Booked" : status}
//                                                         </li>
//                                                     ))}
//                                                 </ul>
//                                             </div>
//                                         )}
//                                     </th>
//                                     {shouldShowActions && <th className="px-6 py-3">Actions</th>}
//                                 </tr>
//                             </thead>
//                             <tbody>
//     {currentBookings.map((booking) => (
//         <tr key={booking.id}>
//             <td className="px-6 py-4 font-medium text-gray-900">{booking.id}</td>
//             <td className="px-6 py-4">{booking.name}</td>
//             <td className="px-6 py-4">{booking.carName}</td>
//             <td className="px-6 py-4">{formatDate(booking.pickupDate)}</td>
// <td className="px-6 py-4">{formatDate(booking.dropoffDate)}</td>


//             <td className="px-6 py-4">
//                 {booking.status === "Approved" ? "Booked" : booking.status}
//             </td>

//             {/* Show action buttons only if status is "Pending" or "Booked" */}
            
           
//                 <td className="px-6 py-4">
//                 {booking.status === 'Pending' && (
//         <>
//             <button className="pending-booking-table-button" onClick={() => handleApprove(booking.id, booking.carId)}>
//                 Approve
//             </button>
//             <button className="pending-booking-table-button pending-booking-table-button-reject" onClick={() => handleReject(booking.id)}>
//                 Reject
//             </button>
//         </>
//     )}
//     {booking.status === 'Approved' && (
//         <button className="pending-booking-table-button" onClick={() => handleRelease(booking.id)}>
//             Release
//         </button>
//     )}
//                 </td>
            
//         </tr>
//     ))}
// </tbody>

//                         </table>
//                         <div className="flex justify-between items-center mt-4 px-4">
//     <span className="text-xs text-gray-600">
//         {indexOfFirstBooking + 1} to {Math.min(indexOfLastBooking, filteredBookings.length)} of {filteredBookings.length} records
//     </span>
//     <nav className="flex items-center space-x-1">
//         {/* Previous Button */}
//         <button 
//             onClick={() => paginate(currentPage - 1)} 
//             disabled={currentPage === 1} 
//             className="px-2 py-1 text-xs rounded border bg-gray-100 hover:bg-gray-200 disabled:opacity-50"
//         >
//             &lt;
//         </button>

//       {/* Page Numbers with Ellipsis */}
//       {Array.from({ length: Math.ceil(filteredBookings.length / bookingsPerPage) }, (_, i) => {
//             if (i + 1 === currentPage || i + 1 === 1 || i + 1 === Math.ceil(filteredBookings.length / bookingsPerPage) || 
//                 Math.abs(i + 1 - currentPage) <= 1) {
//                 return (
//                     <button 
//                         key={i} 
//                         onClick={() => paginate(i + 1)} 
//                         className={`px-2 py-1 text-xs rounded border ${currentPage === i + 1 ? 'bg-blue-500 text-white' : 'bg-gray-100 hover:bg-gray-200'}`}
//                     >
//                         {i + 1}
//                     </button>
//                 );
//             } else if (Math.abs(i + 1 - currentPage) === 2) {
//                 return <span key={i} className="px-1 text-gray-500 text-xs">...</span>;
//             }
//             return null;
//         })}

//         {/* Next Button */}
//         <button 
//             onClick={() => paginate(currentPage + 1)} 
//             disabled={currentPage === Math.ceil(filteredBookings.length / bookingsPerPage)} 
//             className="px-2 py-1 text-xs rounded border bg-gray-100 hover:bg-gray-200 disabled:opacity-50"
//         >
//             &gt;
//         </button>
//     </nav>
// </div>
// </div>

//                 </div>
//             </div>
//         </div>
//     );
// };

// export default BookingList;










import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Sidebar from './Sidebar';
import flag from "../assets/IMG2.png";
import { FaChevronDown, FaChevronUp, FaSearch } from "react-icons/fa";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const BookingList = () => {
    const [bookings, setBookings] = useState([]);
    const [filteredBookings, setFilteredBookings] = useState([]);
    const [statusFilter, setStatusFilter] = useState("All");
    const [showDropdown, setShowDropdown] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [pickupDateFilter, setPickupDateFilter] = useState(null);
    const [dropoffDateFilter, setDropoffDateFilter] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");
    
    const bookingsPerPage = 5;

    useEffect(() => {
        fetchBookings();
    }, []);

    const fetchBookings = async () => {
        try {
            const response = await axios.get('https://carrentalbackend.dockyardsoftware.com/api/Bookings');
            const sortedBookings = response.data.sort((a, b) => b.id - a.id);
            setBookings(sortedBookings);
            setFilteredBookings(sortedBookings);
        } catch (error) {
            console.error("There was an error fetching the bookings!", error);
        }
    };

    const formatDate = (dateString) => {
        if (!dateString) return "";
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
        });
    };

    const handleStatusFilterChange = (status) => {
        setStatusFilter(status);
        setShowDropdown(false);
        setCurrentPage(1);
        applyFilters(status, pickupDateFilter, dropoffDateFilter, searchTerm);
    };

    const applyFilters = (status, pickupDate, dropoffDate, search) => {
        let filtered = [...bookings];

        if (status !== "All") {
            filtered = filtered.filter(b => b.status === status);
        }

        if (pickupDate) {
            filtered = filtered.filter(
                b => formatDate(b.pickupDate) === formatDate(pickupDate)
            );
        }

        if (dropoffDate) {
            filtered = filtered.filter(
                b => formatDate(b.dropoffDate) === formatDate(dropoffDate)
            );
        }

        if (search) {
            const term = search.toLowerCase();
            filtered = filtered.filter(
                b => b.name.toLowerCase().includes(term) || 
                     b.carName.toLowerCase().includes(term) ||
                     b.id.toString().includes(term)
            );
        }

        setFilteredBookings(filtered);
    };

    const handleApprove = async (id) => {
        try {
            await axios.post(`https://carrentalbackend.dockyardsoftware.com/api/Bookings/approve/${id}`);
            updateBookingStatus(id, "Approved");
        } catch (error) {
            console.error("Error approving booking:", error);
        }
    };

    const handleReject = async (id) => {
        try {
            await axios.post(`https://carrentalbackend.dockyardsoftware.com/api/Bookings/reject/${id}`);
            updateBookingStatus(id, "Rejected");
        } catch (error) {
            console.error("Error rejecting booking:", error);
        }
    };

    const handleRelease = async (id) => {
        try {
            await axios.post(`https://carrentalbackend.dockyardsoftware.com/api/Bookings/release/${id}`);
            updateBookingStatus(id, "Released");
        } catch (error) {
            console.error("Error releasing car:", error);
        }
    };

    const updateBookingStatus = (id, status) => {
        setBookings(prevBookings =>
            prevBookings.map(b => b.id === id ? { ...b, status } : b)
        );
        setFilteredBookings(prevFiltered =>
            prevFiltered.map(b => b.id === id ? { ...b, status } : b)
        );
    };

    const handleSearch = (e) => {
        const term = e.target.value;
        setSearchTerm(term);
        applyFilters(statusFilter, pickupDateFilter, dropoffDateFilter, term);
    };

    const clearFilters = () => {
        setStatusFilter("All");
        setPickupDateFilter(null);
        setDropoffDateFilter(null);
        setSearchTerm("");
        setFilteredBookings(bookings);
        setCurrentPage(1);
    };

    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    const indexOfLastBooking = currentPage * bookingsPerPage;
    const indexOfFirstBooking = indexOfLastBooking - bookingsPerPage;
    const currentBookings = filteredBookings.slice(indexOfFirstBooking, indexOfLastBooking);
    const totalPages = Math.ceil(filteredBookings.length / bookingsPerPage);

    const getStatusColor = (status) => {
        switch (status) {
            case "Pending": return "bg-yellow-100 text-yellow-800";
            case "Approved": return "bg-blue-100 text-blue-800";
            case "Rejected": return "bg-red-100 text-red-800";
            case "Released": return "bg-green-100 text-green-800";
            default: return "bg-gray-100 text-gray-800";
        }
    };

    return (
        <div className="flex h-screen bg-gray-50">
            <Sidebar />
            <div className="flex-1 p-6 overflow-auto">
                <img src={flag} alt="Logo" className="h-10 w-auto mr-2" />
                <div className="mt-6 relative">
                    <div className="relative bg-white lg:w-[90%] w-[100%] lg:mx-3 lg:px-10 lg:py-10 p-5 lg:rounded-tl-[3rem] rounded-lg shadow-xl">
                        <h3 className="text-xl font-bold mb-6">Booking Management</h3>

                        {/* Search and Filter Section */}
                        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
                            <div className="relative">
                                <input
                                    type="text"
                                    placeholder="Search bookings..."
                                    className="w-full pl-10 pr-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                    value={searchTerm}
                                    onChange={handleSearch}
                                />
                                <FaSearch className="absolute left-3 top-3 text-gray-400" />
                            </div>
                            
                            <div className="relative">
                                <DatePicker
                                    selected={pickupDateFilter}
                                    onChange={(date) => {
                                        setPickupDateFilter(date);
                                        applyFilters(statusFilter, date, dropoffDateFilter, searchTerm);
                                    }}
                                    dateFormat="yyyy/MM/dd"
                                    className="w-full pl-10 pr-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                    placeholderText="Pickup Date"
                                />
                            </div>
                            
                            <div className="relative">
                                <DatePicker
                                    selected={dropoffDateFilter}
                                    onChange={(date) => {
                                        setDropoffDateFilter(date);
                                        applyFilters(statusFilter, pickupDateFilter, date, searchTerm);
                                    }}
                                    dateFormat="yyyy/MM/dd"
                                    className="w-full pl-10 pr-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                    placeholderText="Dropoff Date"
                                />
                            </div>
                            
                            <button 
                                onClick={clearFilters}
                                className="bg-gray-200 hover:bg-gray-300 text-gray-800 px-4 py-2 rounded-lg transition duration-200"
                            >
                                Clear Filters
                            </button>
                        </div>

                        {/* Bookings Table */}
                        <div className="overflow-x-auto">
                            <table className="w-full text-sm text-left text-gray-500">
                                <thead className="text-xs text-gray-700 bg-gray-100">
                                    <tr>
                                        <th className="px-6 py-3">Id</th>
                                        <th className="px-6 py-3">Customer</th>
                                        <th className="px-6 py-3">Car</th>
                                        <th className="px-6 py-3">Phone number</th>
                                        <th className="px-6 py-3">Pickup Date</th>
                                        <th className="px-6 py-3">Dropoff Date</th>
                                        <th className="px-6 py-3 relative">
                                            <div className="flex items-center">
                                                Status
                                                <button 
                                                    onClick={() => setShowDropdown(!showDropdown)} 
                                                    className="ml-2 text-gray-600 hover:text-gray-800"
                                                >
                                                    {showDropdown ? <FaChevronUp /> : <FaChevronDown />}
                                                </button>
                                            </div>
                                            {showDropdown && (
                                                <div className="absolute top-10 left-0 bg-white shadow-lg rounded-md w-40 z-10 border border-gray-200">
                                                    <ul className="text-sm">
                                                        {["All", "Pending", "Approved", "Rejected", "Released"].map((status) => (
                                                            <li 
                                                                key={status} 
                                                                className={`px-4 py-2 cursor-pointer hover:bg-gray-100 ${
                                                                    statusFilter === status ? "bg-blue-50 text-blue-600" : ""
                                                                }`}
                                                                onClick={() => handleStatusFilterChange(status)}
                                                            >
                                                                {status === "Approved" ? "Booked" : status}
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </div>
                                            )}
                                        </th>
                                        <th className="px-6 py-3">Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {currentBookings.length > 0 ? (
                                        currentBookings.map((booking) => (
                                            <tr key={booking.id} className="bg-white border-b hover:bg-gray-50">
                                                <td className="px-6 py-4 font-medium text-gray-900">{booking.id}</td>
                                                <td className="px-6 py-4">{booking.name}</td>
                                                <td className="px-6 py-4">{booking.carName}</td>
                                                <td className="px-6 py-4">{booking.phoneNumber}</td>
                                                <td className="px-6 py-4">{formatDate(booking.pickupDate)}</td>
                                                <td className="px-6 py-4">{formatDate(booking.dropoffDate)}</td>
                                                <td className="px-6 py-4">
                                                    <span className={`px-3 py-1 rounded-full text-xs font-semibold ${getStatusColor(booking.status)}`}>
                                                        {booking.status === "Approved" ? "Booked" : booking.status}
                                                    </span>
                                                </td>
                                                <td className="px-6 py-4 space-x-2">
                                                    {booking.status === 'Pending' && (
                                                        <>
                                                            <button 
                                                                onClick={() => handleApprove(booking.id)} 
                                                                className="bg-green-500 hover:bg-green-600 text-white px-3 py-1 rounded text-xs transition duration-200"
                                                            >
                                                                Approve
                                                            </button>
                                                            <button 
                                                                onClick={() => handleReject(booking.id)} 
                                                                className="bg-red-500 hover:bg-red-600 text-white px-3 py-1 rounded text-xs transition duration-200"
                                                            >
                                                                Reject
                                                            </button>
                                                        </>
                                                    )}
                                                    {booking.status === 'Approved' && (
                                                        <button 
                                                            onClick={() => handleRelease(booking.id)} 
                                                            className="bg-blue-500 hover:bg-blue-600 text-white px-3 py-1 rounded text-xs transition duration-200"
                                                        >
                                                            Release
                                                        </button>
                                                    )}
                                                    {(booking.status === 'Rejected' || booking.status === 'Released') && (
                                                        <span className="text-gray-400 text-xs">No actions</span>
                                                    )}
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="8" className="px-6 py-4 text-center text-gray-500">
                                                No bookings found matching your criteria
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>

                        {/* Pagination */}
                        <div className="flex flex-col sm:flex-row justify-between items-center mt-4 px-4 py-3 bg-gray-50 rounded-lg">
                            <span className="text-sm text-gray-600 mb-2 sm:mb-0">
                                Showing {indexOfFirstBooking + 1} to {Math.min(indexOfLastBooking, filteredBookings.length)} of {filteredBookings.length} records
                            </span>
                            <nav className="flex items-center space-x-1">
                                <button 
                                    onClick={() => paginate(currentPage - 1)} 
                                    disabled={currentPage === 1} 
                                    className="px-3 py-1 rounded border bg-white hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
                                >
                                    Previous
                                </button>

                                {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
                                    let pageNum;
                                    if (totalPages <= 5) {
                                        pageNum = i + 1;
                                    } else if (currentPage <= 3) {
                                        pageNum = i + 1;
                                    } else if (currentPage >= totalPages - 2) {
                                        pageNum = totalPages - 4 + i;
                                    } else {
                                        pageNum = currentPage - 2 + i;
                                    }

                                    return (
                                        <button 
                                            key={pageNum} 
                                            onClick={() => paginate(pageNum)} 
                                            className={`px-3 py-1 rounded border ${
                                                currentPage === pageNum 
                                                    ? 'bg-blue-500 text-white border-blue-500' 
                                                    : 'bg-white hover:bg-gray-100'
                                            }`}
                                        >
                                            {pageNum}
                                        </button>
                                    );
                                })}

                                {totalPages > 5 && currentPage < totalPages - 2 && (
                                    <span className="px-1">...</span>
                                )}

                                {totalPages > 5 && currentPage < totalPages - 2 && (
                                    <button 
                                        onClick={() => paginate(totalPages)} 
                                        className={`px-3 py-1 rounded border ${
                                            currentPage === totalPages 
                                                ? 'bg-blue-500 text-white border-blue-500' 
                                                : 'bg-white hover:bg-gray-100'
                                        }`}
                                    >
                                        {totalPages}
                                    </button>
                                )}

                                <button 
                                    onClick={() => paginate(currentPage + 1)} 
                                    disabled={currentPage === totalPages} 
                                    className="px-3 py-1 rounded border bg-white hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
                                >
                                    Next
                                </button>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BookingList;